import styled from "styled-components";
import { colorPrimary, colorSecondary, hex2rgba } from "../../colors";

export const StyledBanner = styled.section.attrs({
  className: "banner-section"
})`

  width: 100%;
  display: flex;
  justify-content: center;
  font-family: Pitch Sans Bold;
  background-color: ${colorPrimary};
  
  .banner {
    text-align: center;
    padding: 8px 16px;

    &__content {
      text-decoration: none;
      word-wrap: normal;

      &:hover {
        text-decoration: underline;
        color: ${colorSecondary};

        > span {
          color: ${colorSecondary};
        }
      }
    }

    &__text {
      color: ${hex2rgba(colorSecondary, 0.8)};
    }

    &__link {
      color: ${colorSecondary};
      text-decoration: underline;
      text-decoration-color: ${hex2rgba(colorSecondary, 0.4)};
    }
  }

`;